import { connect } from 'react-redux';

import {
  closeCompareBranchesDialog,
  compareBranches,
  getCompareBranchesDialogSlice,
  fetchDefaultCommitMessage,
} from 'src/redux/branches';
import BaseBranchMergeDialog from 'src/sections/repository/sections/branches/components/dialogs/base-branch-merge-dialog';
import { getIsSiteMessageActive } from 'src/selectors/global-selectors';
import { BucketState } from 'src/types/state';

type MergeDialogStateProps = {
  isOpen: boolean;
  isLoading: boolean;
  sourceBranchName: string | null;
  commitMessage: string;
  isBannerOpen: boolean;
  canDeleteSourceBranch: boolean;
  sourceRepositoryFullName: string | null;
  destinationRepositoryFullName: string | null;
};

function mapStateToProps(state: BucketState): MergeDialogStateProps {
  const {
    isOpen,
    sourceBranchName,
    defaultCommitMessage,
    canDeleteSourceBranch,
    sourceRepositoryFullName,
    destinationRepositoryFullName,
    isLoading,
    isMerge,
  } = getCompareBranchesDialogSlice(state);
  return {
    isOpen: isOpen && isMerge,
    isLoading,
    sourceBranchName,
    commitMessage: defaultCommitMessage,
    isBannerOpen: getIsSiteMessageActive(state),
    canDeleteSourceBranch,
    sourceRepositoryFullName,
    destinationRepositoryFullName,
  };
}

const mapDispatchToProps = {
  onClose: closeCompareBranchesDialog,
  onAction: compareBranches,
  fetchDefaultCommitMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BaseBranchMergeDialog);
